'use strict'
const HeroHome = {
    init: function(){
        if(document.querySelector('.c-hero.home--')) {
            HeroHome.eventGoto();
            HeroHome.animatedBgdText();
        }
    },
    eventGoto:function() {
        const idScroll = document.getElementById('scrollHere');
        if (!idScroll) return;
        document.querySelectorAll('.c-hero__scrollDown').forEach((elt) => {
            elt.addEventListener('click', (e) => {
                e.preventDefault();
                idScroll.scrollIntoView({ behavior: 'smooth' });
            });
        });
    },
    animatedBgdText:function() {

    }
}

export default HeroHome;
